export type { CartCoupon, SaleCoupon } from '@src/domains/coupons/types/coupon';
export {
  CartCouponTypeEnum,
  CartCouponConstraintTypeEnum,
  CouponUsageType,
  SaleCouponTypeEnum,
  SaleCouponConstraintTypeEnum,
} from '@src/domains/coupons/types/coupon';

export { computeCartDiscount } from '@src/domains/coupons/core/computeCartDiscount';
export type { CartDiscount } from '@src/domains/coupons/core/computeCartDiscount';
export { getDiscountCurrencyInfo } from '@src/domains/coupons/core/getDiscountCurrencyInfo';
export { getCouponDiscountCurrencyInfo } from '@src/domains/coupons/core/getCouponDiscountCurrencyInfo';
export { getCouponPercentLabel } from '@src/domains/coupons/core/getCouponPercentLabel';
export { calculateAmountDiscountCents } from '@src/domains/coupons/core/calculateAmountDiscountCents';
export { getCartCostPreviewDiscountCurrencyInfo } from '@src/domains/coupons/core/getCartCostPreviewDiscountCurrencyInfo';
export type {
  CouponInput,
  CouponProductScope,
  ItemWithProductName,
} from '@src/domains/coupons/types/couponProductScope';
export type { CouponLike } from '@src/domains/coupons/core/isCouponValid';
export { isCouponValid } from '@src/domains/coupons/core/isCouponValid';
export {
  getCouponEligibleItems,
  hasCouponEligibleItem,
  isCouponEligibleItem,
  isItemAffectedByCoupon,
} from '@src/domains/coupons/core/couponEligibleItems';
export { getCouponAffectedProductNames } from '@src/domains/coupons/core/getCouponAffectedProductNames';
export { shouldShowCouponAffectedProducts } from '@src/domains/coupons/core/shouldShowCouponAffectedProducts';
export { canUseCoupon } from '@src/domains/coupons/core/canUseCoupon';
